export const ANIMATION_OPTIONS = [
  { value: "none", label: "Brak" },
  { value: "fade-bottom", label: "Fade from bottom" },
  { value: "fade-top", label: "Fade from top" },
  { value: "fade-left", label: "Fade from left" },
  { value: "fade-right", label: "Fade from right" },
];
